import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { baseUserEffects, baseUserReducer } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('users', baseUserReducer.BaseUserReducer),
    EffectsModule.forFeature([baseUserEffects.BaseUserEffects]),
  ],
})
export class BaseUsersStoreModule {}
